import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IContact } from '@leedpulse-monorepo/interfaces';

async function deleteContact(
  contact: IContact,
  auth: Authentication
): Promise<void> {
  try {
    const contactId = contact.id;
    await HttpClient.delete(
      '/contact',
      {
        contactId,
      },
      auth.token,
      {
        'x-api-key': contact.id_api_key,
        'x-contact-id': contact.id,
      }
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    throw new DeleteContactFailure();
  }
}

export class DeleteContactFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default deleteContact;
